import type {
  CancellationState,
  components,
  Paragraph6EEGCreditResponseState
} from "../../types/api.types";

export type Paragraph6ContractResponse =
  components["schemas"]["Paragraph6EEGContract"];

export type Paragraph6ContractPayload = Paragraph6ContractResponse;

export type Paragraph6ContractFormFields = Paragraph6ContractPayload & {
  is_template: boolean;
  has_split_beteiligung?: boolean;
  has_fiktive_strommenge?: boolean;
  project_description?: string; // currently a fixed value in FE, therefore optional for API call
};

export type Paragraph6FinancialDocument = Omit<
  components["schemas"]["Paragraph6EEGCreditResponse"],
  "state"
> & {
  state: Paragraph6EEGCreditResponseState | CancellationState;
  credit_number?: string;
  type?: FinancialDocumentType; // only handled in FE, therefore optional
};

export type Paragraph6CreatableCredit = components["schemas"]["CreditRequest"];

export enum FinancialDocumentType {
  Credit = "credit",
  Cancellation = "cancellation",
  PaymentInformation = "payment_information"
}

export type Paragraph6CreditError =
  components["schemas"]["CreditPeriodCheckResult"];

export type Paragraph6CreditUpdatePayload = Partial<
  components["schemas"]["Paragraph6EEGCreditResponse"]
>;

export type Paragraph6Company = components["schemas"]["Person"];
export type Paragraph6CompanyResponse = Omit<
  components["schemas"]["Person"],
  "id"
> & {
  id: number;
};

export type Paragraph6EEGCreditNumberRangeResponse =
  components["schemas"]["Paragraph6EEGCreditNumberRangeResponse"];

export type Paragraph6EEGCreditNumberRange =
  components["schemas"]["Paragraph6EEGCreditNumberRange"];

export type Paragraph6GemeindeAnteilErzeugerResponse =
  components["schemas"]["GemeindeAnteilErzeuger"];

export type Paragraph6GemeindeAnteilErzeugerPayload =
  Partial<Paragraph6GemeindeAnteilErzeugerResponse>;

export type Paragraph6GeneratorListElement =
  components["schemas"]["Paragraph6UnassignedGeneratorsResponse"];

export type Paragraph6GenerationFeedinShare = Pick<
  Paragraph6GeneratorListElement,
  "weighting" | "anzulegender_wert"
>;

export type Paragraph6EEGCreditData =
  components["schemas"]["Paragraph6EEGCreditDataResponse"];

export type CalculatedGenerationShares =
  Paragraph6EEGCreditData["gemeinde_anteil_erzeuger_data"][number]["calculated_generation_shares"];
